import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import OptionalIcon from '@/svg-icons/optionals';

const AdditionalsSection = ({ additionals }) => {
  if (!additionals) return null;

  return (
    <div className="w-full">
      <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
        <OptionalIcon 
          viewBox="0 0 34.016 34.016" 
          className="text-gray-700 mr-2 w-6 h-6 shrink-0" 
        />
        <FormattedMessage id="additionals" />
      </div>

      <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-additionals-modality">
          <div className="font-bold">
            <FormattedMessage id="modality" />
          </div>
          <FormattedMessage id={additionals.modality} />
        </div>

        {additionals.urgency && (
          <div className="w-1/2 mb-[1vw]" data-cy="order-details-additionals-urgency">
            <div className="font-bold">
              <FormattedMessage id="urgency" />
            </div>
            <FormattedMessage id={additionals.urgency} />
          </div>
        )}
      </div>
    </div>
  );
};

AdditionalsSection.propTypes = {
  additionals: PropTypes.object.isRequired,
};

export default AdditionalsSection;
